import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import {API, ENABLED_LANGUAGES} from "../../../../config";
import TextField from '@material-ui/core/TextField';
import _ from "lodash";
import {connect} from "react-redux";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Utils from "../../../custom/utils";
import {FormControl, InputLabel, MenuItem, Select, InputAdornment} from "@material-ui/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const investor = API.service('investors');
const country = API.service('country');
const compliance = API.service('compliance');
const db_utils = API.service('utils');

const styles = theme => ({
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,

        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    },
    textField: {
        margin: theme.spacing.unit,
    },
});

class Profile extends Component {
    state = {
        _account:         (this.props.investor !== 'new') ? this.props.investor._account : '',
        _firstname:         (this.props.investor !== 'new') ? this.props.investor._firstname : '',
        _middlename:        (this.props.investor !== 'new') ? this.props.investor._middlename : '',
        _surname:           (this.props.investor !== 'new') ? this.props.investor._surname : '',
        _email:             (this.props.investor !== 'new') ? this.props.investor._email : '',
        _language:          (this.props.investor !== 'new') ? (this.props.investor._language ==='CN') ? 'zh_CN' : this.props.investor._language.toLowerCase() : 'en',
        _states:            (this.props.investor !== 'new') ? this.props.investor._states : 0,
        compliance_id:      (this.props.investor !== 'new') ? this.props.investor.compliances[0]._id : 'new',
        _vcontact_value_1:  (this.props.investor !== 'new') ? this.props.investor.compliances[0]._vcontact_value_1 : '',
        _street_address:    (this.props.investor !== 'new') ? this.props.investor.compliances[0]._street_address : '',
        _street_address2:   (this.props.investor !== 'new') ? this.props.investor.compliances[0]._street_address2 : '',
        _city:              (this.props.investor !== 'new') ? this.props.investor.compliances[0]._city : '',
        _state:             (this.props.investor !== 'new') ? this.props.investor.compliances[0]._state : '',
        _zip:               (this.props.investor !== 'new') ? this.props.investor.compliances[0]._zip : '',
        _country:           (this.props.investor !== 'new') ? this.props.investor.compliances[0]._country : '',
        _investments:       (this.props.investor !== 'new') ? this.props.investor.compliances[0]._investments : false,
        _salary:            (this.props.investor !== 'new') ? this.props.investor.compliances[0]._salary : false,
        _bussiness:         (this.props.investor !== 'new') ? this.props.investor.compliances[0]._bussiness : false,
        _gambling:          (this.props.investor !== 'new') ? this.props.investor.compliances[0]._gambling : false,
        _inheritance:       (this.props.investor !== 'new') ? this.props.investor.compliances[0]._inheritance : false,
        _other:             (this.props.investor !== 'new') ? this.props.investor.compliances[0]._other : false,
        _sowexplanation:    (this.props.investor !== 'new') ? this.props.investor.compliances[0]._sowexplanation : false,
        _infodisclosed:     (this.props.investor !== 'new') ? this.props.investor.compliances[0]._infodisclosed : false,
        _bankandmyprotection: (this.props.investor !== 'new') ? this.props.investor.compliances[0]._bankandmyprotection : false,
        _pep:               (this.props.investor !== 'new') ? this.props.investor.compliances[0]._pep : '',
        _sanctioned:        (this.props.investor !== 'new') ? this.props.investor.compliances[0]._sanctioned : '',
        _date_of_birth:     (this.props.investor !== 'new') ? this.props.investor.compliances[0]._date_of_birth : '',
        _gender:            (this.props.investor !== 'new') ? this.props.investor.compliances[0]._gender : '',
        langs: [
            ["en","English"],
            ["zh_CN","Simplified Chinese"],
            ["nl","Netherlands"]
        ],
        selectable: [],
    };

    handleChange = (event) => {
        //console.log(event.target.id,event.target.value, event.target);
        this.setState(_.set({ ...this.state, error: '' }, event.target.id, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    handleCountryChange = (event) => {
        this.setState({
            _country: event.target.value
        });
    };

    statesTotal = (e) => {
        var value = 0
        if(e.target.checked){
             value = parseInt(this.state._states,10) + parseInt(e.target.value,10)
        } else {
            value = parseInt(this.state._states,10) - parseInt(e.target.value,10)
        }

        this.setState({
            _states: value
        })
    }

    sowCheckbox = (e) => {
        var value = 0;
        if(e.target.checked){
            value = '1'
        }

        this.setState(_.set({ ...this.state, error: '' }, e.target.id, value), (e)=>{console.log(this.state);});
        //console.log(e.target.id,value, this.state);
    };

    fetchAllInvestors = () => {
        const app = this;

        db_utils.find().then(inv =>{
            app.props.context.update({
                investors:inv.result
            })
            //console.log(this.props);
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    componentWillMount() {
        const app = this;

        country.find({ query: { $sort: { _short_name: 1 } } }).then(c => {
            //console.log(c);
            app.setState({
                countries: c.data
            })
        });

        this.setState({
            selectable: ENABLED_LANGUAGES
        })
    }

    saveInvestor = () => {
        const app = this;

        let investorPayload = {
            _account: this.state._account,
            _firstname: this.state._firstname,
            _middlename: this.state._middlename,
            _surname: this.state._surname,
            _email: this.state._email,
            _states: this.state._states,
            _account_type: 'I',
            _user_id: this.state._email,
            _language: this.state._language
        }

        let compliancePayload = {
            _vcontact_value_1:  this.state._vcontact_value_1,
            _street_address:    this.state._street_address,
            _street_address2:   this.state._street_address2,
            _city:              this.state._city,
            _state:             this.state._state,
            _zip:               this.state._zip,
            _country:           this.state._country,
            _investments:       this.state._investments,
            _salary:            this.state._salary,
            _bussiness:         this.state._bussiness,
            _gambling:          this.state._gambling,
            _inheritance:       this.state._inheritance,
            _other:             this.state._other,
            _sowexplanation:    this.state._sowexplanation,
            _infodisclosed:     this.state._infodisclosed,
            _bankandmyprotection: this.state._bankandmyprotection,
            _pep:               this.state._pep,
            _sanctioned:        this.state._sanctioned,
        }

        if(this.props.investor !== 'new'){
            /*investor.patch(null,investorPayload,{query:{_account:investorPayload._account,$limit:1}}).then(i=>{
                compliance.patch(null,compliancePayload,{query:{_account:investorPayload._account,$limit:1}}).then(c=>{
                    investor.find({query:{_account:investorPayload._account}}).then(inv=>{
                        app.props.context.update({
                            drawerContent:(<InvestorView investor={inv.data[0]}/>),
                            drawerWidth:'80vw'
                        });
                        app.fetchAllInvestors();
                    });
                })
            })*/
        } else if (this.props.investor === 'new'){
            investorPayload = {
                ...investorPayload,
                _phone:  this.state._vcontact_value_1,
                _street_address:    this.state._street_address,
                _city:              this.state._city,
                _state:             this.state._state,
                _zip:               this.state._zip,
                _country:           this.state._country
            };

            investor.create(investorPayload).then(i=>{
                compliancePayload = {
                    ...compliancePayload,
                    _account: i._account
                };

                compliance.patch(null,compliancePayload,{query:{_account:i._account,$limit:1}}).then(c=>{
                    investor.find({query:{_account:i._account}}).then(inv=>{

                        app.fetchAllInvestors();
                        app.props.context.update({
                            drawerContent:false,
                            drawerWidth:'80vw'
                        });
                    });
                })
            })
        }
    };

    investorState(state) {
        let InvStatus = Utils.returnState(state);
        return(
          <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
        )
    }

    handleLanguageChange = (event) => {
        this.setState({
            _language: event.target.value
        });
    };

    render() {
        const {classes} = this.props;

        return (
            <div style={{overflow:'auto'}}>
                <div className='flex'>
                    <div className="flex-1">
                        <Paper className={'flex p-12'} style={{position:'relative',margin:'2px'}}>

                            <div style={{marginTop:5,width:'33%'}} className={'flex-1'}>
                                <div>
                                    <TextField
                                      id="_email"
                                      label="Email"
                                      className={classes.textFie2ld}
                                      value={this.state._email}
                                      onChange={this.handleChange}
                                      margin="dense"
                                      style={{width:'97%'}}
                                      InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                                {((this.state._states & 2) !== 0) &&
                                                    <FontAwesomeIcon style={{color: 'green'}} icon="check-circle"/>
                                                }

                                                {((this.state._states & 2) === 0) &&
                                                    <FontAwesomeIcon style={{color:'red'}} icon="times-circle" />
                                                }
                                            </InputAdornment>
                                          ),
                                      }}
                                    />
                                </div>
                                <div>
                                    <TextField
                                      id="_vcontact_value_1"
                                      label="Phone"
                                      className={classes.textFi2eld}
                                      value={this.state._vcontact_value_1}
                                      onChange={this.handleChange}
                                      margin="dense"
                                      style={{width:'97%'}}
                                    />
                                </div>
                                <div>
                                    <TextField
                                      id="_date_of_birth"
                                      label="DOB"
                                      className={classes.textFi2eld}
                                      value={this.state._date_of_birth}
                                      onChange={this.handleChange}
                                      margin="dense"
                                      style={{width:'97%'}}
                                    />
                                </div>
                            </div>
                            <div style={{marginTop:5,width:'33%'}} className={'flex-1'}>
                                <div>
                                    <TextField
                                      id="_street_address"
                                      label="Address 1"
                                      className={classes.textFi2eld}
                                      value={this.state._street_address}
                                      onChange={this.handleChange}
                                      margin="dense"
                                      style={{width:'97%'}}
                                    />
                                </div>
                                <div>
                                    <TextField
                                      id="_street_address2"
                                      label="Address 2"
                                      className={classes.textFi2eld}
                                      value={this.state._street_address2}
                                      onChange={this.handleChange}
                                      margin="dense"
                                      style={{width:'97%'}}
                                    />
                                </div>

                                <div className={'flex-1'}>
                                    <div className={'flex'} style={{width:'97%'}}>
                                        <div className={'flex-1'} style={{width:'33%'}}>
                                            <TextField
                                              id="_city"
                                              label="City"
                                              className={classes.textFi2eld}
                                              value={this.state._city}
                                              onChange={this.handleChange}
                                              margin="dense"
                                              style={{width:'97%'}}
                                            />
                                        </div>
                                        <div className={'flex-1'} style={{width:'33%'}}>
                                            <TextField
                                              id="_state"
                                              label="State"
                                              className={classes.te2xtField}
                                              value={this.state._state}
                                              onChange={this.handleChange}
                                              margin="dense"
                                              style={{width:'97%'}}
                                            />
                                        </div>
                                        <div className={'flex-1'} style={{width:'33%'}}>
                                            <TextField
                                              id="_zip"
                                              label="Postcode"
                                              className={classes.text2Field}
                                              value={this.state._zip}
                                              onChange={this.handleChange}
                                              margin="dense"
                                              style={{width:'97%'}}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{marginTop:5,width:'33%'}} className={'flex-1'}>
                                <div>
                                    {(this.state.countries) &&
                                    <FormControl style={{width:'97%'}}>
                                        <InputLabel htmlFor="country">Country:</InputLabel>
                                        <Select
                                          value={this.state._country}
                                          onChange={this.handleCountryChange}
                                          style={{
                                              width: '97%'
                                          }}
                                          inputProps={{
                                              name: 'countries',
                                              id: 'country'
                                          }}
                                          error={this.state.countryError}
                                          helperText={(this.state.countryError) ? "A Country Must be Selected" : ''}
                                        >
                                            <MenuItem value=""/>
                                            {
                                                this.state.countries.map(function (v, i) {
                                                    return (<MenuItem key={i} value={v._iso2}>{v._short_name}</MenuItem>)
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    }
                                </div>
                                <div>
                                    <TextField
                                      id="_gender"
                                      label="Gender"
                                      className={classes.textFi2eld}
                                      value={this.state._gender}
                                      onChange={this.handleChange}
                                      margin="dense"
                                      style={{width:'97%'}}
                                    />
                                </div>
                                <div className={'flex'}>
                                    <div className={'flex-1'} style={{width:'80%'}}>
                                        <FormControl style={{width:'97%'}}>
                                            <InputLabel htmlFor="name-error">Preferred Language: </InputLabel>
                                            <Select
                                              value={this.state._language}
                                              onChange={this.handleLanguageChange}
                                              style={{
                                                  width: '100%'
                                              }}
                                              inputProps={{id: '_language',name: '_language'}}
                                            >
                                                {this.state.langs.map((i) => {
                                                    if(this.state.selectable.includes(i[0])){
                                                        return (
                                                          <MenuItem value={i[0]}>{i[1]}</MenuItem>
                                                        )
                                                    } else {
                                                        return false;
                                                    }
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className={'flex-1'}>
                                        {(this.props.user.role.includes('super') || this.props.user.role.includes('investor_management')) &&
                                            <Button variant="contained" color="secondary" onClick={this.saveInvestor}>Save</Button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Profile))));
